var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from 'lit';
import { property, query, customElement, state } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { uploadPictureSvg } from '../../helpers/elements.js';
let ElementFileUpload = class ElementFileUpload extends LitElement {
    constructor() {
        super(...arguments);
        this.accept = '*/*';
        this.useParentHeight = false;
        this.icon = uploadPictureSvg('h-[24px] w-[24px]');
        this.error = false;
        this.uploadActive = false;
        this.draggingOver = false;
    }
    uploadFile(file) {
        if (!file)
            return;
        this.uploadActive = true;
        if (file.size > 10485760) {
            this.showError(`Il file non ha il formato o le dimensioni corrette.`);
        }
        else {
            this.error = false;
            this.uploadedFile = file;
            this.dispatchEvent(new CustomEvent('uploaded', { detail: { file } }));
        }
        this.uploadActive = false;
    }
    onDrop(event) {
        event.preventDefault();
        this.draggingOver = false;
        Object.entries(event.dataTransfer.files).forEach(([, file]) => {
            let type = file.type;
            if (!file.type?.length) {
                const nameSplit = file.name.split('.');
                type = `.${nameSplit[nameSplit.length - 1]}`;
            }
            if (this.isMimeTypeAccepted(type)) {
                this.uploadFile(file);
            }
            else {
                this.showError(`Il file non ha il formato o le dimensioni corrette.`);
            }
        });
    }
    onUpload(target) {
        if (!target || !target.files?.length)
            return;
        this.uploadFile(target.files[0]);
    }
    deleteFile() {
        this.uploadedFile = undefined;
        this.uploadInput.files = undefined;
        this.uploadInput.value = '';
        this.dispatchEvent(new CustomEvent('deleted'));
    }
    isMimeTypeAccepted(mimeType) {
        mimeType = mimeType.toLowerCase();
        const acceptedMimeTypes = this.accept
            .split(',')
            .map((type) => type.trim().toLowerCase());
        const [type] = mimeType.split('/');
        if (acceptedMimeTypes.includes(mimeType)) {
            return true;
        }
        if (acceptedMimeTypes.includes(`${type}/*`)) {
            return true;
        }
        if (acceptedMimeTypes.includes('*/*')) {
            return true;
        }
        return false;
    }
    showError(msg) {
        this.errorMessage = msg;
        this.error = true;
    }
    renderDragArea() {
        return html ` <button
      class="${classMap({
            'border-danger': this.error,
            'hover:border-chm-focus-red': !this.error,
            'hover:fill-chm-focus-red': !this.error,
            'disabled:border-chm-focus-red': !this.error,
            'md:border-chm-focus-red': this.draggingOver && !this.error,
            'md:fill-chm-focus-red': this.draggingOver && !this.error,
            'h-[174px]': !this.useParentHeight,
            'md:h-[216px]': !this.useParentHeight,
            'mdxx:h-[223px]': !this.useParentHeight,
            'h-full': this.useParentHeight,
        })} w-full border-[1px] border-dashed border-primary-gray fill-chm-red"
      .disabled="${this.uploadActive}"
      @click="${() => this.uploadInput.click()}"
      @drop="${this.onDrop}"
      @dragenter="${() => {
            this.draggingOver = true;
        }}"
      @dragover="${(event) => {
            event.preventDefault();
        }}"
      @dragleave="${() => {
            this.draggingOver = false;
        }}"
    >
      <div
        class="pointer-events-none flex h-full flex-col p-[20px] text-chm-gray"
      >
        <div class="flex text-left">${this.hint}</div>
        <div
          .hidden="${!this.uploadActive}"
          class="bg-loader-animated mt-[18px] md:mt-[24px] h-[24px] w-[24px] self-center bg-no-repeat"
        ></div>
        <div
          .hidden="${this.uploadActive}"
          class="mt-[18px] md:mt-[24px] h-[24px] w-[24px] self-center bg-no-repeat"
        >
          ${this.icon}
        </div>
        <div class="pl-[16px] text-chm-red pt-[10px]" .hidden="${!this.error}">
          ${this.errorMessage}
        </div>
      </div>
    </button>`;
    }
    get preview() {
        const imgUploaded = this.uploadedFile.type.includes('image');
        return html `
      <div
        class="${classMap({
            'h-[174px]': !this.useParentHeight,
            'md:h-[216px]': !this.useParentHeight,
            'mdxx:h-[223px]': !this.useParentHeight,
            'h-full': this.useParentHeight,
        })} flex w-full items-center justify-center border-[1px] border-dashed border-primary-gray bg-contain bg-center bg-no-repeat hover:border-chm-focus-red"
        style="background-image: url('${imgUploaded ? URL.createObjectURL(this.uploadedFile) : ''}')"
      >
        <div .hidden="${imgUploaded}">${this.uploadedFile.name}</div>
        <div
          class="bg-delete h-[40px] w-[40px] cursor-pointer"
          @click="${this.deleteFile}"
        ></div>
      </div>
    `;
    }
    render() {
        return html ` <div class="body w-full">
        <div .hidden="${!this.label?.length}" class="select-none font-bold">
          ${this.label}
        </div>
        ${this.uploadedFile ? this.preview : this.renderDragArea()}
      </div>
      <input
        hidden
        type="file"
        accept="${this.accept}"
        class="upload-input"
        @change=${(e) => this.onUpload(e.target)}
      />`;
    }
    createRenderRoot() {
        return this;
    }
};
__decorate([
    property({ type: String })
], ElementFileUpload.prototype, "hint", void 0);
__decorate([
    property({ type: String })
], ElementFileUpload.prototype, "label", void 0);
__decorate([
    property({ type: String })
], ElementFileUpload.prototype, "errorMessage", void 0);
__decorate([
    property({ type: String })
], ElementFileUpload.prototype, "accept", void 0);
__decorate([
    property({ type: Boolean })
], ElementFileUpload.prototype, "useParentHeight", void 0);
__decorate([
    property({ type: Object })
], ElementFileUpload.prototype, "icon", void 0);
__decorate([
    state()
], ElementFileUpload.prototype, "error", void 0);
__decorate([
    state()
], ElementFileUpload.prototype, "uploadActive", void 0);
__decorate([
    state()
], ElementFileUpload.prototype, "uploadedFile", void 0);
__decorate([
    state()
], ElementFileUpload.prototype, "draggingOver", void 0);
__decorate([
    query('.upload-input')
], ElementFileUpload.prototype, "uploadInput", void 0);
ElementFileUpload = __decorate([
    customElement('element-file-upload')
], ElementFileUpload);
export { ElementFileUpload };
//# sourceMappingURL=element-file-upload.js.map